import { ClientOnly, createFileRoute } from "@tanstack/react-router";

import { HOME_OG_IMAGE, HOME_OG_IMAGE_ALT, HomePage } from "@/web/routes/-home/HomePage";
import { MarketingFooter } from "@/web/routes/-marketing/MarketingFooter";
import { MarketingNavbar } from "@/web/routes/-marketing/MarketingNavbar";
import { appUrl } from "@/web/lib/siteUrls";

const TITLE = "WITH.CO";
const DESCRIPTION =
  "We help local businesses and their communities own the buildings they make valuable — together.";

export const Route = createFileRoute("/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      // Open Graph. Explicit dimensions + alt let scrapers render the card
      // without first fetching the image, and keep the crop predictable.
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:image", content: HOME_OG_IMAGE },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: HOME_OG_IMAGE_ALT },
      { property: "og:url", content: appUrl("/") },
      { property: "og:type", content: "website" },
      // Twitter Card
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: HOME_OG_IMAGE },
      { name: "twitter:image:alt", content: HOME_OG_IMAGE_ALT },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex w-full flex-col overflow-x-clip">
      {/* Navbar depends on Clerk + scroll position — client-only to avoid SSR hangs. */}
      <ClientOnly>
        <MarketingNavbar />
      </ClientOnly>

      <HomePage />

      <div data-nav-theme="white">
        <MarketingFooter />
      </div>
    </div>
  );
}
